export default {
  title: {
    add: 'add bank',
    update: 'edit bank'
  },
  label: {
    bankAccount: 'bank holder',
    bankBranch: 'branch',
    bankName: 'bank name',
    bankNo: 'bank account',
    createBy: 'create by',
    createTime: 'update time',
    id: 'Primary key id',
    merchatNo: 'MerchantNo',
    updateBy: 'updater',
    updateTime: 'update time',
    action: 'operate'
  },
  rules: {
    bankAccount: 'bank holder cannot be empty',
    bankBranch: 'Branch name cannot be empty',
    bankName: 'Bank name cannot be empty',
    bankNo: {
      required: 'Bank account cannot be empty',
      type: 'Bank account must be a number',
      symboltype: 'Bank account must be a number',
      min: 'Bank account The length must be greater than or equal to 5',
      length: 'The length of the bank card number must be greater than 4 and less than 31'
    },
    merchatNo: 'MerchantNo cannot be empty',
    bankCode: 'Bank code cannot be empty'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/withdrawBank.js